import * as React from "react";
import {DateInput, Edit, ImageField, ImageInput, required, SimpleForm, TextInput} from 'react-admin';

export const CategoryEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput disabled label="Id" source="id" />
            <TextInput label="Название" source="name" validate={required()} multiline={true} fullWidth={true} />
            <TextInput label="Описание" source="description" validate={required()} multiline={true} fullWidth={true} />
            <DateInput label="Архивация" source="archived" />
            {/*<ImageInput source="image" label="Изображение" placeholder={<p>Перетащите файл в область загрузки</p>}>*/}
            {/*    <ImageField source="src" title="title"/>*/}
            {/*</ImageInput>*/}
        </SimpleForm>
    </Edit>
);